import React, { useEffect, useState } from 'react'
import { ScrollView, Text, View } from 'react-native'
import HeaderWithBack from '../../components/Header/headerWithBack';
import { useCssStyle } from '../../customHook/getCssStyle';
import { useTranslation } from 'react-i18next';
import { ImageComp } from '../../components/Image/Image';
import { getCleanUrl, toBool } from '../../utils/Helper';
import CustomPressable from '../../components/customPressable/customPressable';
import { useDispatch, useSelector } from 'react-redux';
import { getMySpaBooking } from '../../Redux/Actions/spaBookingAction';
import { formatTime } from '../../js/formatTime';
import { formatDate } from '../../js/formatDate';
import SpaBookingUpdate from './spaBookingUpdate';
import { EDIT, HEART } from '../../assets';

const SpaBooking1 = (props) => {
    const { currentWidget, getExistingReservations, bookingObj, shouldProceedOnDeprecatedAddonsWarning, updateBookingObj, handleNext, handleGoBack } = props;

    const getStyles = useCssStyle();
    const { t } = useTranslation();
    const dispatch = useDispatch(); 

    const { serverTimeDataObj } = useSelector(state => state.serverDateTimeSlice)
    const { extraConfigParam } = useSelector(state => state.deviceConfigSlice);
    const TIME_FORMAT = extraConfigParam?.TIME_FORMAT_MERIDIEM || false;

    const [showUpdateReservationPopup, setShowUpdateReservationPopup] = useState(false);
    const [updateReservationDetails, setUpdateReservationDetails] = useState(null);
    const [cancelReservationDetails, setCancelReservationDetails] = useState(null);
    const [showCancelReservation, setShowCancelReservation] = useState(false);
    

    const getSpaDetails = () => {
        const spa = bookingObj.spa_data.find(
            (data) => data.spalocationId == bookingObj?.spaLocationId
        );
        return spa;
    }

    const groupingByDate = (data) => {
        const groupedAccToDay = new Map();

        if(!data){
            return groupedAccToDay
        }
        data.sort((a, b) => {
            return (
                new Date(a.date).getTime() -
                new Date(b.date).getTime()
            );
        });

        data.forEach((d) => {
            const groupingKey = formatDate(d.date);
            if (groupedAccToDay.has(groupingKey)) {
                const keyData = groupedAccToDay.get(groupingKey);
                keyData.push(d);
            } else {
                groupedAccToDay.set(groupingKey, [d]);
            }
        });

        return groupedAccToDay;
    };

    const shouldDisappearCancelButtonBasedOnCurrentTime =  (reservationDetails) => {
        const currentTime = serverTimeDataObj?.date.replace("Z","");
        let reservationTime = reservationDetails.date;

        const currentTimeMiliSeconds = new Date(currentTime).getTime();
        const reservationTimeMiliSeconds = new Date(reservationTime).getTime();
            
        const hoursCancelButtonDisappearBefore =  t("spaBooking.hoursCancelButtonDisappearBefore", { defaultValue: 2 })
        
        return !( (reservationTimeMiliSeconds - currentTimeMiliSeconds) > (hoursCancelButtonDisappearBefore * 60 * 60 * 1000));
    }



    useEffect(()=> {
        getExistingReservations()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        showUpdateReservationPopup ? 
            <SpaBookingUpdate
                currentWidget={currentWidget}
                updateReservationDetails={updateReservationDetails}

                handleNext={()=> {
                    console.log("Handle next ncalled : ")
                    handleNext(updateReservationDetails)
                }}
                handleGoBack={()=>{
                    setUpdateReservationDetails(null);
                    setShowUpdateReservationPopup(false);
                }}
                bookingObj={bookingObj}
                shouldProceedOnDeprecatedAddonsWarning={shouldProceedOnDeprecatedAddonsWarning}
            />
        : <View style={getStyles(['widgetRootContainer', 'spaBookingRootContainer'])} id='spaBookingRootContainer'>
            <HeaderWithBack handleCustomBackPress={handleGoBack} />

            <ScrollView
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'spaBookingMainContainer'])} 
                showsVerticalScrollIndicator={false}
                id='spaBookingMainContainer'
            >
                <View style={getStyles(['widgetmainContainerHeaderContainer', 'spaBookingHeaderContainer'])} id='spaBookingHeaderContainer'>
                    {
                        currentWidget?.widgetHeaderImageUrl && 
                            <ImageComp
                                source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} 
                                style={getStyles(['widgetmainContainerHeaderImg', 'spaBookingHeaderImg'])} id={"spaBookingHeaderImg"}
                            />
                    }
                    <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'spaBookingHeaderTitleContainer'])} id='spaBookingHeaderTitleContainer'>
                        <ImageComp source={HEART} style={getStyles(["spaBookingHeaderTitleImage"])} id="spaBookingHeaderTitleImage"/>
                        <Text style={getStyles(['widgetmainContainerHeaderTitle', 'spaBookingHeaderTitle'])} id='spaBookingHeaderTitle'>
                            {t("spaBooking.my_reservation.heading")}
                        </Text>
                        <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'spaBookingBookingHeaderSubTitle'])} id='spaBookingBookingHeaderSubTitle'>
                            {t("spaBooking.my_reservation.subheading")}
                        </Text>
                        <View style={getStyles(["horizontalline"])} id='horizontalline'></View>
                    </View>

                </View>
                
                <View style={getStyles(['widgetmainContainerChildContainer', 'spaBookingBookingMainContainerChildContainer'])} id='spaBookingBookingMainContainerChildContainer'>

                    <View style={getStyles(["spaBookingMyReservationHeadingContainer"])} id='spaBookingMyReservationHeadingContainer'>
                        <Text style={getStyles(["spaBookingMyReservationHeading"])} id='spaBookingMyReservationHeading'>
                            {`${t("spaBooking.myReservation")}${bookingObj?.myExistingReservation?.length > 0 ? "s" : ""}`}
                        </Text>
                    </View>

                    {bookingObj?.myExistingReservation?.length ? 
                        Array.from(groupingByDate(bookingObj?.myExistingReservation)?.entries)
                            .map(([day, dataOnThatDay]) => {
                                return <>
                                    <Text style={getStyles(["spaBookingHeadingDayText"])} id='spaBookingHeadingDayText'>{day}</Text>
                                    {dataOnThatDay?.map((reservation)=> {
                                        return <View style={getStyles(["spaBookingDayContainer"])} id='spaBookingDayContainer'>
                                            <View style={getStyles(["spaBookingDayServiceContainer"])} id='spaBookingDayServiceContainer'>
                                                <Text style={getStyles(["spaBookingDayServiceName"])} id='spaBookingDayServiceName'>{reservation.lines[0].serviceName}</Text>

                                                <Text style={getStyles(["spaBookingDayServiceDate"])} id='spaBookingDayServiceDate'>
                                                    {formatTime(reservation.date.split('T')[1], toBool(TIME_FORMAT))}
                                                </Text>
                                            </View>

                                            <View style={getStyles(["spaBookingDayButtonContainer"])} id='spaBookingDayButtonContainer'>
                                                {reservation.cancelled ? <Text style={getStyles(["spaBookingDayCancelButton"])}>{t("spaBooking.cancelled")}</Text>
                                                : <>
                                                    <CustomPressable 
                                                        style={getStyles(["spaBookingDayUpdateButtonContainer"])}
                                                        id="spaBookingDayUpdateButtonContainer"
                                                        onPress={()=> {
                                                            setShowUpdateReservationPopup(true);
                                                            setUpdateReservationDetails(reservation)
                                                        }}
                                                    >
                                                        <ImageComp 
                                                            style={getStyles(['spaBookingEditButton'])}
                                                            id={"spaBookingEditButton"}
                                                            source={EDIT}
                                                        />
                                                    </CustomPressable>
                                                    
                                                    {serverTimeDataObj && shouldDisappearCancelButtonBasedOnCurrentTime(reservation) ? <></> :
                                                        <CustomPressable 
                                                            style={getStyles(["spaBookingDayCancelButtonContainer"])}
                                                            id="spaBookingDayCancelButtonContainer"
                                                            onPress={()=> {
                                                                setCancelReservationDetails(reservation);
                                                            }}
                                                        >
                                                            <Text>Cancel</Text>
                                                        </CustomPressable>
                                                    }

                                                </>}
                                            </View>
                                        </View>
                                    })}
                                </>
                            })
                    : <View style={getStyles(["spaBookingNoReservationErrorContainer"])} id='spaBookingNoReservationErrorContainer'>
                        <Text style={getStyles(["spaBookingNoReservationError"])} id='spaBookingNoReservationError'>
                            {bookingObj?.cachedApiDataStore && bookingObj?.cachedApiDataStore?.hasOwnProperty(`my_reservations_${bookingObj?.spaLocationId}`)
                                ? t("spaBooking.no_reservation_found") 
                                : t("spaBooking.errors.error")
                            }
                        </Text>
                    </View>}
                    

                </View>
                
            </ScrollView>
            
            <View id='spaBookingNextButtonContainer' style={getStyles(['spaBookingNextButtonContainer'])}>
                <CustomPressable style={getStyles(["primaryBtn"])} onPress={()=> handleNext()} id="primaryBtn">
                    <Text style={getStyles(["primaryBtnTxt"])} id='primaryBtnTxt'>
                        {t("spaBooking.make_a_reservation")}
                    </Text>
                </CustomPressable>
                {/* <CustomPressable style={getStyles(["secondaryBtn"])} onPress={()=> handleGoBack()} id="secondaryBtn">
                    <Text style={getStyles(["secondaryBtnTxt"])} id='secondaryBtnTxt'>
                        {t("spaBooking.back")}
                    </Text>
                </CustomPressable> */}
            </View>
        </View>
    )
}

export default SpaBooking1
